import { createIcon } from '../shared'

const LikeIcon = createIcon(
  ({ color }) => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4561 2C13.2032 2 14.6191 3.41809 14.6191 5.16699V8.83301H18.501C20.8549 8.83301 22.5364 11.1148 21.8418 13.3662L20.3535 18.1914C19.6855 20.3566 17.6857 21.833 15.4219 21.833H7.99316C7.8541 21.9374 7.68137 22 7.49414 22H3.49805C2.67071 21.9998 2.00009 21.3282 2 20.5V12.166C2.00026 11.338 2.67082 10.6672 3.49805 10.667H6.94531L8.95898 6.63672V3.83301C8.95916 2.82066 9.77867 2.00003 10.79 2H11.4561ZM3.66504 20.333H6.66211V12.376C6.65016 12.362 6.63887 12.3476 6.62793 12.333H3.66504V20.333ZM10.79 3.66699C10.6982 3.66703 10.6242 3.74113 10.624 3.83301V6.83301C10.624 6.96233 10.5939 7.09038 10.5361 7.20605L8.32715 11.627V20.167H15.4219C16.9555 20.1669 18.3102 19.166 18.7627 17.6992L20.251 12.874C20.6146 11.6948 19.7339 10.5 18.501 10.5H13.7871C13.3274 10.5 12.9553 10.1271 12.9551 9.66699V5.16699C12.9551 4.33857 12.2836 3.66699 11.4561 3.66699H10.79Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'FacebookLikeIcon',
)

export { LikeIcon }
